import React, { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import { Link, useLocation } from "react-router-dom";
import service from "../../assets/images/banner/ai-rpa.png";
import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/ai-rpa.png";
import videoSource from "../../assets/videos/vdo-1.mp4";

import IntelligentAutomation from "../IntelligentAutomation";

const DigitalMarketing = () => {
  pageTitle("AI & RPA");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    setFormData({ name: "", email: "", subject: "", phone: "", message: "" });
  };

  const servicesData = [
    { id: 1, title: "AI & RPA", slug: "/RPA-AI" },
    { id: 2, title: "Data & Analytics", slug: "/Data-Analytics" },
    { id: 3, title: "Web Development", slug: "/Web-Development" },
    { id: 4, title: "Digital Consulting", slug: "/digital-consultancy" },
    { id: 5, title: "Whatsapp Services", slug: "/Whatsapp-estore" },
    // { id: 6, title: "Data Science", slug: "/Data-Science" },
  ];

  const renderServices = () =>
    servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/content-marketing" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));

  return (
    <>
      <HeaderOne />

      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${g1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative"></div>
        </div>
      </section>

      <div className="service__details p_relative">
        <div className="auto-container">
          <div className="row service__details__row d-flex flex-wrap">
            {/* Right Paragraph */}
            <div className="col-xl-8 col-lg-12 col-md-12 service__right">
              <figure>
                <img src={service} alt="" className="service-images" />
              </figure>

              <h2>AI & Robotic Process Automation (RPA) Platform Services</h2>

              <p>
                RPA and AI empower organizations to accelerate innovation and
                enhance operational efficiency by automating critical business
                processes. Automation reduces the burden of repetitive, manual
                tasks, enabling employees to focus on higher-value, strategic
                initiatives while intelligent systems operate seamlessly in the
                background.
              </p>
              <p className="siw-rpa-desc">
                By leveraging robotic process automation (RPA), artificial
                intelligence, machine learning, natural language processing, and
                computer vision, <span className="SiW">SiW</span> delivers
                intelligent automation consulting services that support
                end-to-end digital transformation. With over seven years of
                technology consulting experience across multiple industries,{" "}
                <span className="SiW">SiW</span> combines deep expertise and
                proven resources to help organizations digitize, optimize, and
                scale their operations.
              </p>
            </div>
            {/* Left Sidebar */}
            <div className="col-xl-4 col-lg-6 col-md-12 service__details__left">
              <div
                className="sidebar__widget_network"
                style={{ backgroundImage: `url(${basebg})` }}
              >
                <h3 style={{ paddingBottom: "20px" }}>AI & RPA</h3>
                <video controls style={{ width: "100%", marginRight: "10px" }}>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>

              <div className="sidebar__widget">
                <div className="all__service">
                  <h4>All Services</h4>
                </div>
                <ul className="service__details__1__cat">{renderServices()}</ul>
              </div>
            </div>
            {/* Intelligent Automation */}
            <div className="col-12 IA">
              <IntelligentAutomation />
            </div>
          </div>
        </div>
      </div>

      <FooterOne />

      {/* Responsive Ordering CSS */}
      <style>{`
        @media (max-width: 991px) {
          .service__details__row {
            display: flex;
            flex-direction: column;
          }
          .service__right { order: 1; }
          .IA { order: 2; margin: 20px 0; }
          .service__details__left { order: 3; }
        }

        @media (min-width: 992px) {
          .service__details__row {
            flex-direction: row;
          }
          .service__right, .IA, .service__details__left {
            order: initial;
            margin: 0;
          }
        }
      `}</style>
    </>
  );
};

export default DigitalMarketing;
